import React from 'react'
import { Field, ErrorMessage } from 'formik'
import TextError from './TextError.js'
import '../../components/GeneralCss.css'
import TimePicker from 'react-time-picker';
import "react-time-picker/dist/TimePicker.css";
import "react-time-picker/dist/TimePicker.css";
function TimeControl(props) {
    const { label, name, ...rest } = props
    return (
            <div className="formSingleElement">
              {
                    label.includes("*") ? 
                
                        <label className="formSingleElementLabel"  htmlFor={name}>{label.replace('*',"")}
                        <span className="required-field"> * </span></label>
                    :
                        <label className="formSingleElementLabel"  htmlFor={name}>{label}</label>
                }
                <Field  name={name} className="form-control">
                {
                    ({form, field}) => {
                        const { setFieldValue } = form
                        const { value } = field
                        return <TimePicker minTime="09:00:00"  maxtime="19:00:00" locale='en-US' minutePlaceholder="MM" hourPlaceholder="HH" disableClock={true} id={name} {...field} {...rest} value={value}  />
                    }
                }
            </Field>                
            <ErrorMessage name={name} component={TextError}/>
            </div>
    )
} 



export default TimeControl